module.exports = [{
  "id": "LEGITEXT000006070721",
  "nature": "CODE",
  "titre": "Code civil",
  "titrefull": "Code civil",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1803-03-14T23:50:39.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-09-30T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070721",
  "mtime": 1547844397,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069441",
  "nature": "CODE",
  "titre": "Code de commerce",
  "titrefull": "Code de commerce (ancien)",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1807-09-19T23:50:39.000Z",
  "date_fin": "2000-09-20T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2000-09-20T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006069441",
  "mtime": 1547243161,
  "texte_id": null
}, {
  "id": "LEGITEXT000005634379",
  "nature": "CODE",
  "titre": "Code de commerce",
  "titrefull": "Code de commerce",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2000-09-20T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000005634379",
  "mtime": 1548104719,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071071",
  "nature": "CODE",
  "titre": "Code de déontologie de la police nationale",
  "titrefull": "Code de déontologie de la police nationale",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1986-03-18T23:00:00.000Z",
  "date_fin": "2013-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2013-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071071",
  "mtime": 1481920765,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071103",
  "nature": "CODE",
  "titre": "Code de déontologie de la profession de commissaire aux comptes",
  "titrefull": "Code de déontologie de la profession de commissaire aux comptes",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "2005-11-16T23:00:00.000Z",
  "date_fin": "2007-03-26T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2007-03-26T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": "<p>Conseil d'Etat, décisions n° 288460, 288465, 288474, 288485, en date du 24 mars 2006, article 1er : Le décret du 16 novembre 2005 portant approbation du code de déontologie est annulé en tant qu'il ne prévoit pas de mesures transitoires relatives aux mandats de commissaires aux comptes en cours à la date de son entrée en vigueur.  </p>",
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071103",
  "mtime": 1502132491,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070159",
  "nature": "CODE",
  "titre": "Code de déontologie des agents de police municipale.",
  "titrefull": "Code de déontologie des agents de police municipale",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "2003-08-05T22:00:00.000Z",
  "date_fin": "2013-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2013-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006070159",
  "mtime": 1530640838,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074232",
  "nature": "CODE",
  "titre": "Code de déontologie des architectes",
  "titrefull": "Code de déontologie des architectes",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1980-03-24T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "1992-09-22T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074232",
  "mtime": 1475691325,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072636",
  "nature": "CODE",
  "titre": "Code de déontologie des chirurgiens-dentistes",
  "titrefull": "Code de déontologie des chirurgiens-dentistes",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1967-08-08T23:00:00.000Z",
  "date_fin": "2004-08-07T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2004-08-07T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006072636",
  "mtime": 1505413162,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072664",
  "nature": "CODE",
  "titre": "Code de déontologie des médecins",
  "titrefull": "Code de déontologie des médecins",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1979-06-29T22:00:00.000Z",
  "date_fin": "1995-09-07T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "1995-09-07T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006072664",
  "mtime": 1528136872,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074510",
  "nature": "CODE",
  "titre": "Code de déontologie des professionnels de l'expertise comptable",
  "titrefull": "Code de déontologie des professionnels de l'expertise comptable",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "2007-09-27T22:00:00.000Z",
  "date_fin": "2012-03-31T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2012-03-31T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006074510",
  "mtime": 1473964158,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072635",
  "nature": "CODE",
  "titre": "Code de déontologie des sages-femmes",
  "titrefull": "Code de déontologie des sages-femmes",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1949-10-04T23:00:00.000Z",
  "date_fin": "2004-08-07T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2004-08-07T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006072635",
  "mtime": 1505413162,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072634",
  "nature": "CODE",
  "titre": "Code de déontologie médicale",
  "titrefull": "Code de déontologie médicale",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1995-09-07T22:00:00.000Z",
  "date_fin": "2004-08-07T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2004-08-07T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006072634",
  "mtime": 1543865674,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072360",
  "nature": "CODE",
  "titre": "Code de déontologie vétérinaire",
  "titrefull": "Code de déontologie vétérinaire",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1992-02-21T23:00:00.000Z",
  "date_fin": "2003-08-06T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2003-08-06T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006072360",
  "mtime": 1500922552,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070933",
  "nature": "CODE",
  "titre": "Code de justice administrative",
  "titrefull": "Code de justice administrative",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2000-12-30T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070933",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070884",
  "nature": "CODE",
  "titre": "Code de justice militaire",
  "titrefull": "Code de justice militaire",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1983-04-30T22:00:00.000Z",
  "date_fin": "2007-05-11T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2007-05-11T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006070884",
  "mtime": 1522951064,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071360",
  "nature": "CODE",
  "titre": "Code de justice militaire.",
  "titrefull": "Code de justice militaire (nouveau)",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2007-05-10T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2017-02-28T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071360",
  "mtime": 1547844396,
  "texte_id": null
}, {
  "id": "LEGITEXT000037701019",
  "nature": "CODE",
  "titre": "Code de la commande publique",
  "titrefull": "Code de la commande publique",
  "titrefull_s": null,
  "etat": "VIGUEUR_DIFF",
  "date_debut": "2019-03-31T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-26T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000037701019",
  "mtime": 1547064501,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069565",
  "nature": "CODE",
  "titre": "Code de la consommation",
  "titrefull": "Code de la consommation",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1993-07-26T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006069565",
  "mtime": 1547844396,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069472",
  "nature": "CODE",
  "titre": "Code de la consommation des boissons et des mesures contre l'alcoolisme applicable dans la collectivité territoriale de Mayotte",
  "titrefull": "Code de la consommation des boissons et des mesures contre l'alcoolisme applicable dans la collectivité territoriale de Mayotte",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1992-10-05T23:00:00.000Z",
  "date_fin": "2000-06-21T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2000-06-21T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006069472",
  "mtime": 1446224575,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074096",
  "nature": "CODE",
  "titre": "Code de la construction et de l'habitation.",
  "titrefull": "Code de la construction et de l'habitation",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1977-03-09T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074096",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074069",
  "nature": "CODE",
  "titre": "Code de l'action sociale et des familles",
  "titrefull": "Code de l'action sociale et des familles",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2000-12-22T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074069",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071307",
  "nature": "CODE",
  "titre": "Code de la défense.",
  "titrefull": "Code de la défense",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2004-12-20T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2019-01-05T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071307",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072637",
  "nature": "CODE",
  "titre": "Code de la famille et de l'aide sociale.",
  "titrefull": "Code de la famille et de l'aide sociale",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1956-01-23T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2015-07-16T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006072637",
  "mtime": 1544819666,
  "texte_id": null
}, {
  "id": "LEGITEXT000037673300",
  "nature": "CODE",
  "titre": "Code de la légion d'honneur, de la Médaille militaire et de l'ordre national du Mérite",
  "titrefull": "Code de la légion d'honneur, de la Médaille militaire et de l'ordre national du Mérite",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2018-11-30T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-11-30T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071007",
  "mtime": 1546371865,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071007",
  "nature": "CODE",
  "titre": "Code de la Légion d'honneur et de la médaille militaire",
  "titrefull": "Code de la légion d'honneur et de la médaille militaire",
  "titrefull_s": null,
  "etat": "MODIFIE",
  "date_debut": "1962-12-06T23:00:00.000Z",
  "date_fin": "2018-11-30T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-11-30T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071007",
  "mtime": 1546371865,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074067",
  "nature": "CODE",
  "titre": "Code de la mutualité",
  "titrefull": "Code de la mutualité",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1985-07-25T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074067",
  "mtime": 1547243157,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071189",
  "nature": "CODE",
  "titre": "Code de la nationalité française",
  "titrefull": "Code de la nationalité française",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1945-10-19T23:00:00.000Z",
  "date_fin": "1993-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "1993-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071189",
  "mtime": 1543951419,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069414",
  "nature": "CODE",
  "titre": "Code de la propriété intellectuelle",
  "titrefull": "Code de la propriété intellectuelle",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1992-07-02T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-22T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006069414",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071190",
  "nature": "CODE",
  "titre": "Code de la recherche",
  "titrefull": "Code de la recherche",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2004-06-15T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-08-05T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071190",
  "mtime": 1547671668,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074947",
  "nature": "CODE",
  "titre": "Code de la route",
  "titrefull": "Code de la route (ancien)",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1954-07-09T23:00:00.000Z",
  "date_fin": "2001-05-31T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2001-05-31T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006074947",
  "mtime": 1512759722,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074228",
  "nature": "CODE",
  "titre": "Code de la route.",
  "titrefull": "Code de la route",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2001-05-26T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074228",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006075116",
  "nature": "CODE",
  "titre": "Code de l'artisanat",
  "titrefull": "Code de l'artisanat",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1952-07-19T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2017-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006075116",
  "mtime": 1547844397,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072665",
  "nature": "CODE",
  "titre": "Code de la santé publique",
  "titrefull": "Code de la santé publique",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1953-10-06T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006072665",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000025503132",
  "nature": "CODE",
  "titre": "Code de la sécurité intérieure",
  "titrefull": "Code de la sécurité intérieure",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2012-04-30T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000025503132",
  "mtime": 1548104717,
  "texte_id": null
}, {
  "id": "LEGITEXT000006073189",
  "nature": "CODE",
  "titre": "Code de la sécurité sociale.",
  "titrefull": "Code de la sécurité sociale",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1958-10-15T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006073189",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074234",
  "nature": "CODE",
  "titre": "Code de l'aviation civile",
  "titrefull": "Code de l'aviation civile",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1967-04-08T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074234",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070667",
  "nature": "CODE",
  "titre": "Code de la voirie routière",
  "titrefull": "Code de la voirie routière",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1989-06-23T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-05T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070667",
  "mtime": 1544733941,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071191",
  "nature": "CODE",
  "titre": "Code de l'éducation",
  "titrefull": "Code de l'éducation",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2000-06-21T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071191",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000023983208",
  "nature": "CODE",
  "titre": "Code de l'énergie",
  "titrefull": "Code de l'énergie",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2011-05-31T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000023983208",
  "mtime": 1548104717,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071014",
  "nature": "CODE",
  "titre": "Code de l'enseignement technique",
  "titrefull": "Code de l'enseignement technique",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1956-09-18T23:00:00.000Z",
  "date_fin": "2000-06-21T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2000-06-21T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071014",
  "mtime": 1536690751,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070158",
  "nature": "CODE",
  "titre": "Code de l'entrée et du séjour des étrangers et du droit d'asile.",
  "titrefull": "Code de l'entrée et du séjour des étrangers et du droit d'asile",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2005-01-18T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070158",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074220",
  "nature": "CODE",
  "titre": "Code de l'environnement",
  "titrefull": "Code de l'environnement",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2000-09-20T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074220",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074224",
  "nature": "CODE",
  "titre": "Code de l'expropriation pour cause d'utilité publique",
  "titrefull": "Code de l'expropriation pour cause d'utilité publique",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1977-04-13T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-11-24T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074224",
  "mtime": 1546030260,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070882",
  "nature": "CODE",
  "titre": "Code de l'industrie cinématographique",
  "titrefull": "Code de l'industrie cinématographique",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1956-01-30T23:00:00.000Z",
  "date_fin": "2010-06-13T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2010-06-13T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006070882",
  "mtime": 1510772735,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071737",
  "nature": "CODE",
  "titre": "Code de l'Office national interprofessionnel du blé",
  "titrefull": "Code de l'Office national interprofessionnel du blé",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1937-12-28T00:00:00.000Z",
  "date_fin": "2007-08-31T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2003-09-05T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071737",
  "mtime": 1530556610,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071164",
  "nature": "CODE",
  "titre": "Code de l'organisation judiciaire",
  "titrefull": "Code de l'organisation judiciaire",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1978-03-17T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071164",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074075",
  "nature": "CODE",
  "titre": "Code de l'urbanisme",
  "titrefull": "Code de l'urbanisme",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1973-01-02T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074075",
  "mtime": 1547671668,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070716",
  "nature": "CODE",
  "titre": "Code de procédure civile",
  "titrefull": "Code de procédure civile",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1975-12-31T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070716",
  "mtime": 1547757058,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070680",
  "nature": "CODE",
  "titre": "Code de procédure civile (1807)",
  "titrefull": "Code de procédure civile (1807)",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1806-12-31T23:50:39.000Z",
  "date_fin": "2007-12-21T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2007-12-21T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006070680",
  "mtime": 1539023405,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071154",
  "nature": "CODE",
  "titre": "Code de procédure pénale",
  "titrefull": "Code de procédure pénale",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1957-12-30T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2019-01-06T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071154",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006073984",
  "nature": "CODE",
  "titre": "Code des assurances",
  "titrefull": "Code des assurances",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1976-07-10T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006073984",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006073422",
  "nature": "CODE",
  "titre": "Code des caisses d'épargne",
  "titrefull": "Code des caisses d'épargne",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1952-06-30T23:00:00.000Z",
  "date_fin": "2005-08-24T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2005-08-24T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006073422",
  "mtime": 1446224575,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070162",
  "nature": "CODE",
  "titre": "Code des communes",
  "titrefull": "Code des communes",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1977-03-19T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2016-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070162",
  "mtime": 1547243157,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070300",
  "nature": "CODE",
  "titre": "Code des communes de la Nouvelle-Calédonie",
  "titrefull": "Code des communes de la Nouvelle-Calédonie",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2001-07-04T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-07-14T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070300",
  "mtime": 1546546656,
  "texte_id": null
}, {
  "id": "LEGITEXT000006075115",
  "nature": "CODE",
  "titre": "Code des débits de boissons et des mesures contre l'alcoolisme",
  "titrefull": "Code des débits de boissons et des mesures contre l'alcoolisme",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1955-05-20T23:00:00.000Z",
  "date_fin": "2003-05-26T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2003-05-26T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006075115",
  "mtime": 1540840028,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071570",
  "nature": "CODE",
  "titre": "Code des douanes",
  "titrefull": "Code des douanes",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1948-12-31T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071570",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071645",
  "nature": "CODE",
  "titre": "Code des douanes de Mayotte",
  "titrefull": "Code des douanes de Mayotte",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1992-10-15T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2016-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071645",
  "mtime": 1511290345,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070666",
  "nature": "CODE",
  "titre": "Code des instruments monétaires et des médailles",
  "titrefull": "Code des instruments monétaires et des médailles",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1952-06-28T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2009-05-13T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070666",
  "mtime": 1446224605,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070249",
  "nature": "CODE",
  "titre": "Code des juridictions financières",
  "titrefull": "Code des juridictions financières",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1994-12-05T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2017-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070249",
  "mtime": 1547757058,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069564",
  "nature": "CODE",
  "titre": "Code des marchés publics",
  "titrefull": "Code des marchés publics (édition 2001)",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "2001-09-08T22:00:00.000Z",
  "date_fin": "2004-05-31T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2004-05-31T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006069564",
  "mtime": 1446224575,
  "texte_id": null
}, {
  "id": "LEGITEXT000005627819",
  "nature": "CODE",
  "titre": "Code des marchés publics",
  "titrefull": "Code des marchés publics (édition 2006)",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "2006-08-31T22:00:00.000Z",
  "date_fin": "2016-03-31T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2016-03-31T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000005627819",
  "mtime": 1545425756,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069562",
  "nature": "CODE",
  "titre": "Code des marchés publics",
  "titrefull": "Code des marchés publics (édition 1964)",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1964-07-20T23:00:00.000Z",
  "date_fin": "2001-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2001-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006069562",
  "mtime": 1505413162,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072666",
  "nature": "CODE",
  "titre": "Code des marchés publics.",
  "titrefull": "Code des marchés publics (édition 2004)",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "2004-01-07T23:00:00.000Z",
  "date_fin": "2006-08-31T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2006-08-31T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006072666",
  "mtime": 1446224575,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070302",
  "nature": "CODE",
  "titre": "Code des pensions civiles et militaires de retraite",
  "titrefull": "Code des pensions civiles et militaires de retraite",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1952-06-30T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-15T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070302",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074066",
  "nature": "CODE",
  "titre": "Code des pensions de retraite des marins français du commerce, de pêche ou de plaisance",
  "titrefull": "Code des pensions de retraite des marins français du commerce, de pêche ou de plaisance",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1968-03-30T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2017-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074066",
  "mtime": 1547243157,
  "texte_id": null
}, {
  "id": "LEGITEXT000031712069",
  "nature": "CODE",
  "titre": "Code des pensions militaires d'invalidité et des victimes de guerre.",
  "titrefull": "Code des pensions militaires d'invalidité et des victimes de guerre",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2016-12-31T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-08T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074068",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074068",
  "nature": "CODE",
  "titre": "Code des pensions militaires d'invalidité et des victimes de la guerre.",
  "titrefull": "Code des pensions militaires d'invalidité et des victimes de la guerre",
  "titrefull_s": null,
  "etat": "MODIFIE",
  "date_debut": "1951-04-25T23:00:00.000Z",
  "date_fin": "2016-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-08T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074068",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074233",
  "nature": "CODE",
  "titre": "Code des ports maritimes",
  "titrefull": "Code des ports maritimes",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1978-04-01T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2016-08-14T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074233",
  "mtime": 1544210874,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070987",
  "nature": "CODE",
  "titre": "Code des postes et des communications électroniques",
  "titrefull": "Code des postes et des communications électroniques",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1962-03-13T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070987",
  "mtime": 1547757058,
  "texte_id": null
}, {
  "id": "LEGITEXT000025024948",
  "nature": "CODE",
  "titre": "Code des procédures civiles d'exécution",
  "titrefull": "Code des procédures civiles d'exécution",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2012-05-31T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000025024948",
  "mtime": 1547243156,
  "texte_id": null
}, {
  "id": "LEGITEXT000031366350",
  "nature": "CODE",
  "titre": "Code des relations entre le public et l'administration",
  "titrefull": "Code des relations entre le public et l'administration",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2015-12-31T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000031366350",
  "mtime": 1548104717,
  "texte_id": null
}, {
  "id": "LEGITEXT000023086525",
  "nature": "CODE",
  "titre": "Code des transports",
  "titrefull": "Code des transports",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2010-11-30T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000023086525",
  "mtime": 1548104717,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071344",
  "nature": "CODE",
  "titre": "Code des tribunaux administratifs et des cours administratives d'appel",
  "titrefull": "Code des tribunaux administratifs et des cours administratives d'appel",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1973-08-31T23:00:00.000Z",
  "date_fin": "2000-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2000-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071344",
  "mtime": 1530727978,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071188",
  "nature": "CODE",
  "titre": "Code disciplinaire et pénal de la marine marchande.",
  "titrefull": "Code disciplinaire et pénal de la marine marchande",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1926-12-19T00:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2017-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071188",
  "mtime": 1539023404,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071646",
  "nature": "CODE",
  "titre": "Code du blé",
  "titrefull": "Code du blé",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1936-04-23T23:00:00.000Z",
  "date_fin": "2006-05-25T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2006-05-25T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071646",
  "mtime": 1530556610,
  "texte_id": null
}, {
  "id": "LEGITEXT000020908868",
  "nature": "CODE",
  "titre": "Code du cinéma et de l'image animée",
  "titrefull": "Code du cinéma et de l'image animée",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2009-07-25T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000020908868",
  "mtime": 1547844396,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070208",
  "nature": "CODE",
  "titre": "Code du domaine de l'Etat",
  "titrefull": "Code du domaine de l'Etat",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1962-03-13T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-10-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070208",
  "mtime": 1547671668,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074235",
  "nature": "CODE",
  "titre": "Code du domaine de l'Etat et des collectivités publiques applicable à la collectivité territoriale de Mayotte",
  "titrefull": "Code du domaine de l'Etat et des collectivités publiques applicable à la collectivité territoriale de Mayotte",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1993-06-30T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2011-11-24T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074235",
  "mtime": 1479325695,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074237",
  "nature": "CODE",
  "titre": "Code du domaine public fluvial et de la navigation intérieure",
  "titrefull": "Code du domaine public fluvial et de la navigation intérieure",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1956-10-12T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2014-05-27T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074237",
  "mtime": 1547243157,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074236",
  "nature": "CODE",
  "titre": "Code du patrimoine",
  "titrefull": "Code du patrimoine",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2004-02-23T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074236",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071335",
  "nature": "CODE",
  "titre": "Code du service national",
  "titrefull": "Code du service national",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1972-07-13T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-11-06T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071335",
  "mtime": 1547757058,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071318",
  "nature": "CODE",
  "titre": "Code du sport.",
  "titrefull": "Code du sport",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2006-01-31T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071318",
  "mtime": 1547844396,
  "texte_id": null
}, {
  "id": "LEGITEXT000006074073",
  "nature": "CODE",
  "titre": "Code du tourisme.",
  "titrefull": "Code du tourisme",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2004-12-31T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006074073",
  "mtime": 1547671668,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072050",
  "nature": "CODE",
  "titre": "Code du travail",
  "titrefull": "Code du travail",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1973-01-02T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006072050",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072052",
  "nature": "CODE",
  "titre": "Code du travail applicable à Mayotte.",
  "titrefull": "Code du travail applicable à Mayotte",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1991-03-05T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-11-06T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006072052",
  "mtime": 1547844397,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072051",
  "nature": "CODE",
  "titre": "Code du travail maritime",
  "titrefull": "Code du travail maritime",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1926-02-15T00:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2016-12-19T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006072051",
  "mtime": 1547844397,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071657",
  "nature": "CODE",
  "titre": "Code du vin",
  "titrefull": "Code du vin",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1936-12-24T00:00:00.000Z",
  "date_fin": "2003-09-05T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2003-09-05T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071657",
  "mtime": 1449258147,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070239",
  "nature": "CODE",
  "titre": "Code électoral",
  "titrefull": "Code électoral",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1964-10-27T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070239",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071514",
  "nature": "CODE",
  "titre": "Code forestier",
  "titrefull": "Code forestier",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1979-02-06T23:00:00.000Z",
  "date_fin": "2012-06-30T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2012-06-30T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071514",
  "mtime": 1543865674,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071556",
  "nature": "CODE",
  "titre": "Code forestier de Mayotte",
  "titrefull": "Code forestier de Mayotte",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1992-10-15T23:00:00.000Z",
  "date_fin": "2015-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2015-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071556",
  "mtime": 1519327763,
  "texte_id": null
}, {
  "id": "LEGITEXT000025244092",
  "nature": "CODE",
  "titre": "Code forestier (nouveau)",
  "titrefull": "Code forestier (nouveau)",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2012-06-30T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000025244092",
  "mtime": 1547757058,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070299",
  "nature": "CODE",
  "titre": "Code général de la propriété des personnes publiques.",
  "titrefull": "Code général de la propriété des personnes publiques",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2006-06-30T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-30T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070299",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070633",
  "nature": "CODE",
  "titre": "Code général des collectivités territoriales",
  "titrefull": "Code général des collectivités territoriales",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1996-02-23T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070633",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069568",
  "nature": "CODE",
  "titre": "Code général des impôts annexe 1, CGIAN1.",
  "titrefull": "Code général des impôts, annexe 1",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1974-01-02T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2017-06-30T22:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006069568",
  "mtime": 1529690407,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069569",
  "nature": "CODE",
  "titre": "Code général des impôts, annexe 2, CGIAN2.",
  "titrefull": "Code général des impôts, annexe 2",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1967-09-15T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006069569",
  "mtime": 1547844396,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069574",
  "nature": "CODE",
  "titre": "Code général des impôts, annexe 3, CGIAN3.",
  "titrefull": "Code général des impôts, annexe 3",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1967-09-28T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006069574",
  "mtime": 1548104717,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069576",
  "nature": "CODE",
  "titre": "Code général des impôts, annexe 4, CGIAN4.",
  "titrefull": "Code général des impôts, annexe 4",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1975-12-30T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006069576",
  "mtime": 1547844396,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069577",
  "nature": "CODE",
  "titre": "Code général des impôts, CGI.",
  "titrefull": "Code général des impôts",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1952-02-13T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006069577",
  "mtime": 1548104717,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071785",
  "nature": "CODE",
  "titre": "Code minier",
  "titrefull": "Code minier",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1956-08-20T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2017-03-01T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071785",
  "mtime": 1545425754,
  "texte_id": null
}, {
  "id": "LEGITEXT000023501962",
  "nature": "CODE",
  "titre": "Code minier (nouveau)",
  "titrefull": "Code minier (nouveau)",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2011-02-28T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": null,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2017-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": null,
  "page_fin_publi": null,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000023501962",
  "mtime": 1544125672,
  "texte_id": null
}, {
  "id": "LEGITEXT000006072026",
  "nature": "CODE",
  "titre": "Code monétaire et financier",
  "titrefull": "Code monétaire et financier",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2000-12-31T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006072026",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071029",
  "nature": "CODE",
  "titre": "CODE PENAL",
  "titrefull": "Code pénal (ancien)",
  "titrefull_s": null,
  "etat": "ABROGE",
  "date_debut": "1810-02-11T23:50:39.000Z",
  "date_fin": "1994-02-28T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "1994-02-28T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_non_vigueur",
  "cid": "LEGITEXT000006071029",
  "mtime": 1533581036,
  "texte_id": null
}, {
  "id": "LEGITEXT000006070719",
  "nature": "CODE",
  "titre": "Code pénal",
  "titrefull": "Code pénal",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1990-08-31T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-11-24T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006070719",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071367",
  "nature": "CODE",
  "titre": "Code rural",
  "titrefull": "Code rural (nouveau)",
  "titrefull_s": null,
  "etat": "MODIFIE",
  "date_debut": "1979-11-30T23:00:00.000Z",
  "date_fin": "2010-05-07T22:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071367",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006071366",
  "nature": "CODE",
  "titre": "Code rural ancien",
  "titrefull": "Code rural (ancien)",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1955-04-18T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2012-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071366",
  "mtime": 1539627962,
  "texte_id": null
}, {
  "id": "LEGITEXT000022197698",
  "nature": "CODE",
  "titre": "Code rural et de la pêche maritime",
  "titrefull": "Code rural et de la pêche maritime",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "2010-05-07T22:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006071367",
  "mtime": 1548104718,
  "texte_id": null
}, {
  "id": "LEGITEXT000006069583",
  "nature": "CODE",
  "titre": "Livre des procédures fiscales",
  "titrefull": "Livre des procédures fiscales",
  "titrefull_s": null,
  "etat": "VIGUEUR",
  "date_debut": "1938-05-31T23:00:00.000Z",
  "date_fin": "2998-12-31T23:00:00.000Z",
  "autorite": null,
  "ministere": null,
  "num": null,
  "num_sequence": 0,
  "nor": null,
  "date_publi": "2998-12-31T23:00:00.000Z",
  "date_texte": "2998-12-31T23:00:00.000Z",
  "derniere_modification": "2018-12-31T23:00:00.000Z",
  "origine_publi": null,
  "page_deb_publi": 0,
  "page_fin_publi": 0,
  "visas": null,
  "signataires": null,
  "tp": null,
  "nota": null,
  "abro": null,
  "rect": null,
  "dossier": "code_en_vigueur",
  "cid": "LEGITEXT000006069583",
  "mtime": 1547844396,
  "texte_id": null
}];